<template>
  <generic-modal :title="$t('sign')" ref="generic_modal">
    <p class="mb-5">
      {{
        $t(
          "please sign here to confirm that you have received your payment. we value your commitment"
        )
      }}
    </p>
    <div class="title is-6">{{ $t("signature area") }}</div>
    <canvas
      ref="signature_pad"
      class="signature-pad"
      width="576"
      height="270"
    ></canvas>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-check"></i>
        </span>
        <span>{{ $t("confirm signature") }}</span>
      </button>
      <button class="button is-rounded" @click="clear">
        <span class="icon">
          <i class="fa fa-eraser"></i>
        </span>
        <span>{{ $t("clear") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  success_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import SignaturePad from "signature_pad";

export default {
  name: "SignModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      signature_pad_instance: null,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.name || !v.meta.email;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    open(uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.meta.uuid = uuid;
    },
    save() {
      let v = this;
      let signature = v.signature_pad_instance.toDataURL("image/jpeg");
      let data = { signature: signature, uuid: v.meta.uuid };

      post("/staff/payroll/review/approve", data)
        .then((response) => {
          success_message(this.$t("payroll approved successfully"));
          // v.$emit("signed");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          console.error(error);
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          this.isApproving = false;
        });

      // put("/document-sign/sign/signature", data)
      //   .then(() => {
      //     v.$emit("signed");
      //     v.$refs.generic_modal.close_modal();
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //     v.error = generate_error_message_text(error);
      //   });
    },
    set_initial_state() {
      let v = this;
      v.signature_pad_instance.clear();
      v.meta = {
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
    clear() {
      let v = this;
      v.signature_pad_instance.clear();
    },
  },
  mounted() {
    let v = this;
    var signaturePad = new SignaturePad(v.$refs.signature_pad, {
      backgroundColor: "rgb(255, 255, 255)",
      penColor: "rgb(0, 0, 0)",
    });
    v.signature_pad_instance = signaturePad;
  },
  watch: {},
};
</script>
<style>
.signature-pad {
  border: 1px solid aliceblue !important;
  border-radius: 5px;
  /* width: 100%; */
}
</style>
